import { UPDATE_VISIBILITY_SETTINGS } from '../actions';

export function visibilitySettings(state = {}, action) {
  switch (action.type) {
    case UPDATE_VISIBILITY_SETTINGS: {
      return { ...state, ...action.settings };
    }
    default:
      return state;
  }
}
